import type { FC } from "react";
import { Icon } from "../../shared/components/Icon/Icon";
import { useMatchMedia } from "../../shared/hooks/useMatchMedia";
import classes from "./Register.module.scss";

export const Register: FC = () => {
	const { isMobile }: any = useMatchMedia();
	return (
		<div className={classes.wrapper}>
			<span className={classes.superscript}>
				Join our vibrant marketplace community today!
			</span>
			<h2 className={classes.title}>
				<span>Register now</span> and unlock a world of unique shopping
				experiences.
			</h2>
			<a href="#">
				<button className={classes.button}>
					<Icon
						className={classes.icon}
						size={!isMobile ? 28 : 20}
						name="cart"
					/>
					<h4> Marketpace</h4>
				</button>
			</a>
		</div>
	);
};
